import React from 'react';
import EmptyStateBase from '@alltrails/shared/components/EmptyStateBase';
import PrimaryButtonLarge from '@alltrails/shared/components/PrimaryButtonLarge';

import * as styles from './styles/styles.module.scss';
import WarningIcon from '../../../../assets/images/icons/warning.svg';

import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

type ErrorFallbackProps = {
  retryErrorPage: () => void;
};

const ErrorFallback = ({ retryErrorPage }: ErrorFallbackProps): JSX.Element => (
  <div className={styles.fallbackContainer}>
    <EmptyStateBase
      className={styles.fallbackContainer}
      icon={<img src={WarningIcon} alt={StringConstantsMixin.strings.SOMETHING_WENT_WRONG} />}
      title={StringConstantsMixin.strings.SOMETHING_WENT_WRONG}
      subText={StringConstantsMixin.strings.CLICK_RETRY}
      cta={
        <PrimaryButtonLarge name={StringConstantsMixin.strings.COMMUNITY.EMPTY_STATES.RETRY} className={styles.button} onClick={retryErrorPage}>
          {StringConstantsMixin.strings.COMMUNITY.EMPTY_STATES.RETRY}
        </PrimaryButtonLarge>
      }
    />
  </div>
);

export default ErrorFallback;
